import { render, staticRenderFns } from "./ConsultaAlertaJuridico.vue?vue&type=template&id=a35d9bc6&scoped=true&"
import script from "./ConsultaAlertaJuridico.vue?vue&type=script&lang=js&"
export * from "./ConsultaAlertaJuridico.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaAlertaJuridico.vue?vue&type=style&index=0&id=a35d9bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d9bc6",
  null
  
)

export default component.exports